import Immutable from 'immutable';
import _ from 'lodash';

const is = Immutable.is.bind(Immutable);

/* Implementation of shallowEquals that supports ImmutableJS structures */
export function shallowEquals(a, b) {
  if (a === b || is(a, b)) {
    return true;
  }

  if (typeof a !== 'object' || a === null || typeof b !== 'object' || b === null) {
    return false;
  }

  const keysA = Object.keys(a);
  const keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
  // eslint-disable-next-line no-restricted-syntax
  for (const key of keysA) {
    if (!bHasOwnProperty(key) || !is(a[key], b[key])) {
      return false;
    }
  }

  return true;
}

/* isEmpty that supports both native arrays/objects and Immutable iterables (lists, maps, etc) */
export function isEmpty(obj) {
  if (Immutable.Iterable.isIterable(obj)) {
    return obj.isEmpty();
  }

  return _.isEmpty(obj);
}
